export default {
  endpoint: "wss://kusama.rpc.robonomics.network/",
  isDevelopmentAccounts: false,
  subscription: "4GgRRojuoQwKCZP9wkB69ZxJY4JprmHtpzEzqJLjnqu4jk1r",
  discord: "https://discord.com/invite/5UWNGNaAUf"
};
